var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-card",
    {
      staticClass: "soli-round",
      staticStyle: { overflow: "hidden" },
      attrs: { ripple: true },
    },
    [
      _c(
        "div",
        {
          staticClass: "soli-round",
          class: _vm.selected ? "selected" : null,
          staticStyle: { cursor: "pointer" },
          on: {
            click: function ($event) {
              return _vm.selectStat(_vm.stat, $event)
            },
          },
        },
        [
          _c("div", { staticClass: "pa-2", class: _vm.stat.color }, [
            _c(
              "div",
              {
                staticClass: "white--text flex justify-center subtitle-2",
                class: _vm.caption ? "caption" : null,
              },
              [
                _vm._v(
                  "\n                " +
                    _vm._s(
                      _vm.showMonth ? _vm.globalMomentMonthFull() : "Current"
                    ) +
                    "\n            "
                ),
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass:
                  "white--text flex justify-center whitespace-no-wrap subtitle-2",
                class: _vm.caption ? "caption" : null,
              },
              [
                _vm._v(
                  "\n                " +
                    _vm._s(_vm.stat.title) +
                    "\n            "
                ),
              ]
            ),
          ]),
          _vm._v(" "),
          _vm.stat.value || _vm.stat.value === 0
            ? _c(
                "v-card-title",
                { staticClass: "py-3 soli-grey justify-center" },
                [
                  _vm._v(
                    "\n            " +
                      _vm._s(`${_vm.stat.value}${_vm.percent ? "%" : ""}`) +
                      "\n        "
                  ),
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          !_vm.stat.value && _vm.stat.value !== 0
            ? _c("v-skeleton-loader", {
                staticClass: "mx-auto",
                attrs: { "max-width": "300", type: "list-item" },
              })
            : _vm._e(),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }